.info-icon {
  height: 13px;
  width: 13px;
  color: var(--grey-600);
}
